<div class="row">
    <div class="col-md-12 row m-0 justify-content-center">
        <h1>404</h1>
    </div>
    <div class="col-md-12 row m-0 justify-content-center">
        Page Not Found.
    </div>
</div>